import type {FC} from 'react';

import type {Props} from './types';

import {AvatarPlaceholder} from '../../../../../uikit/AvatarPlaceholder';
import * as S from '../styles';

export const ProgramChannelsListItemJSX: FC<Props> = ({
  avatarTitle,
  avatarUrl,
  isDisabled,
  subtitles,
  title,
}) => {
  return (
    <S.Container>
      <S.AvatarImage
        fadeOut={isDisabled}
        placeholder={<AvatarPlaceholder text={avatarTitle} />}
        src={avatarUrl ?? ''}
      />
      <S.Content>
        <S.TitleContainer>
          <S.Title nativeProps={{numberOfLines: 1}}>{title}</S.Title>
        </S.TitleContainer>
        {subtitles?.map(subtitle => (
          <S.Subtitle key={subtitle}>{subtitle}</S.Subtitle>
        ))}
      </S.Content>
    </S.Container>
  );
};
